<div
  class="filter-item"
  [matMenuTriggerFor]="cbsasFilter"
  #trigger="matMenuTrigger"
  [ngClass]="{ active: isOpen || selectedValues.length > 0 }"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
>
  <span>
    Filter markets
    <span *ngIf="selectedValues.length > 0">({{ selectedValues.length }})</span>
    <span *ngIf="selectedValues.length === 0">(All)</span>
  </span>
  <app-shared-icon name="chevron-down-2"></app-shared-icon>
</div>

<mat-menu
  #cbsasFilter="matMenu"
  xPosition="after"
  yPosition="below"
  class="filters-mat-menu cbsas-filter-menu"
>
  <div
    class="filter-dropdown markets with-padding"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <h4>Select one or more Metro/City, County or ZIP</h4>

    <ng-container *ngIf="defaultSelectedValues">
      <app-account-setup-markets
        (selectedChange)="handleSelectedChange($event)"
        [defaultSelected]="defaultSelectedValues"
        [filters]="true"
        [error]="false"
        [disabled]="false"
      ></app-account-setup-markets>
    </ng-container>

    <div class="-mb-1">
      <app-filter-v2-buttons
        (resetAction)="resetCbsas()"
        (applyAction)="closeMenu()"
        resetLabel="Show all"
        position="right"
        [hideReset]="!selectedValues.length"
        [showEmptySpace]="!selectedValues.length"
      ></app-filter-v2-buttons>
    </div>
  </div>
</mat-menu>
